var _rect, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgHisFileIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 30,
    viewBox: "0 1 18 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.835938,
    width: 18,
    height: 18.3333,
    rx: 5,
    fill: "#E1E0F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83464 5.83594H6.5013C6.04297 5.83594 5.66797 6.21094 5.66797 6.66927V13.3359C5.66797 13.7943 6.04297 14.1693 6.5013 14.1693H11.5013C11.9596 14.1693 12.3346 13.7943 12.3346 13.3359V8.33594L9.83464 5.83594ZM9.41797 12.9193H7.33464V12.0859H9.41797V12.9193ZM10.668 11.6693H7.33464V10.8359H10.668V11.6693ZM10.668 10.4193H7.33464V9.58594H10.668V10.4193ZM9.41797 8.7526V6.46094L11.7096 8.7526H9.41797Z",
    fill: "#5654DE"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHisFileIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/HIS_File_Icon.4e300ef2.svg";
export { ForwardRef as ReactComponent };